export default __webpack_public_path__ + "static/media/gallery-10.70cb5516.png";